module.exports = __webpack_public_path__ + "img/nav_img_02.0047a305.jpg";